module.exports = __webpack_public_path__ + "static/img/m2_t2c.05710863.jpg";